import React from 'react';
import './App.css';
import IndexPage from "./pages/IndexPage";
import {LanguageProvider} from "./contexts/LanguageContext";
import {ConfigProvider} from "antd";
import {Analytics} from '@vercel/analytics/react';

function App() {
    return (
        // 在 ConfigProvider 中设置
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#f97316',
                },
            }}
        >
            <LanguageProvider>
                <div className="App">
                    <IndexPage/>
                    <Analytics/>
                </div>
            </LanguageProvider>
        </ConfigProvider>
    );
}

export default App;
